





























































































































































import { Component, Vue } from 'vue-property-decorator'

import { getSeurantajaksot } from '@/api/erikoistuva'
import ElsaButton from '@/components/button/button.vue'
import store from '@/store'
import { Seurantajakso } from '@/types'
import { SeurantajaksoTila } from '@/utils/constants'
import { sortByDateDesc } from '@/utils/date'
import { toastFail } from '@/utils/toast'

@Component({
  components: {
    ElsaButton
  }
})
export default class SeurantakeskustelutViewErikoistuva extends Vue {
  seurantajaksot: Seurantajakso[] = []
  naytaKuvaus = false
  items = [
    {
      text: this.$t('etusivu'),
      to: { name: 'etusivu' }
    },
    {
      text: this.$t('seurantakeskustelut'),
      active: true
    }
  ]
  loading = true

  async mounted() {
    this.loading = true
    try {
      this.seurantajaksot = (await getSeurantajaksot()).data.sort(
        (s1: Seurantajakso, s2: Seurantajakso) => {
          return sortByDateDesc(s1.alkamispaiva, s2.alkamispaiva)
        }
      )
    } catch {
      toastFail(this, this.$t('seurantakeskustelujen-hakeminen-epaonnistui'))
      this.seurantajaksot = []
    }
    this.loading = false
  }

  get account() {
    return store.getters['auth/account']
  }

  toggleKuvaus() {
    this.naytaKuvaus = !this.naytaKuvaus
  }

  showHyvaksytty(seurantajakso: Seurantajakso) {
    return seurantajakso.tila === SeurantajaksoTila.HYVAKSYTTY
  }

  showKorjattavaa(seurantajakso: Seurantajakso) {
    return seurantajakso.tila === SeurantajaksoTila.PALAUTETTU_KORJATTAVAKSI
  }

  showKouluttajaArvioinut(seurantajakso: Seurantajakso) {
    return seurantajakso.tila === SeurantajaksoTila.ODOTTAA_YHTEISIA_MERKINTOJA
  }

  showOdottaaHyvaksyntaa(seurantajakso: Seurantajakso) {
    return seurantajakso.tila === SeurantajaksoTila.ODOTTAA_HYVAKSYNTAA
  }

  koulutusjaksotLabel(seurantajakso: Seurantajakso) {
    return seurantajakso.koulutusjaksot.map((k) => k.nimi).join(', ')
  }
}
